import { useParams } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';

import AuctionVideoStream from '../BiddingConsole/components/AuctionVideoStream/AuctionVideoStream';
import AuctionVideoPageHeaderMeta from './AuctionVideoPageHeaderMeta';

type RouteParams = {
    catalogId: string;
};

const AboutUsPage = () => {
    const { catalogId: catalogIdString } = useParams<RouteParams>();
    const catalogId = Number(catalogIdString);

    return (
        <Page>
            <BackgroundOverride />
            <AuctionVideoPageHeaderMeta catalogId={catalogId} />
            <AuctionVideoStream catalogId={catalogId} />
        </Page>
    );
};

export default AboutUsPage;

const Page = styled.div`
    background-color: ${({ theme }) => theme.colors.black};
    height: 100%;
    align-items: center;
    justify-content: center;
`;

const BackgroundOverride = createGlobalStyle`
    html {
        background-color: ${({ theme }) => theme.colors.black};
    }
`;
